import React, { Component } from "react";

import Modal from 'react-bootstrap/Modal';
import { Button } from "react-bootstrap";
import ButtonIcon from "../../button";
import { DropzoneComponent } from "react-dropzone-component";
import Queued from '../../../../img/icon-sm-upload-blk.png';
import Icons from '../../icon';
import './upload.component.css'
const componentConfig = {
	postUrl: "http://localhost:3000/"
}

var ReactDOMServer = require('react-dom/server');

const eventHandlers = {

};

const djsConfig = {
	maxFilesize: 1022956339,
	maxFiles: 1,
	autoProcessQueue: false,
	parallelUploads: 50,
	uploadMultiple: false,
	dictDefaultMessage: 'Drag and drop or <b class="purple">browse</b> your files',
	dictInvalidFileType: 'Invalid file.',
	dictMaxFilesExceeded: 'Maximum number of files reached!',
	dictFileTooBig: 'File too big.',
	previewTemplate: ReactDOMServer.renderToStaticMarkup(
		<div className="dz-preview dz-file-preview">
			<div className="dz-details">
				<div>
					<Icons name="x-solid" size="12px" customClassName="dz-delete" />
				</div>
				<div className="dz-filename">
					<span data-dz-name />
				</div>
				<div className="dz-filesize">
					<span data-dz-size />
				</div>
				<div className="dz-upload-status">
					<img src={Queued} alt="file status icon" className="dz-filestatus-image" />
					<div className="dz-filestatus">Queued</div>
				</div>
			</div>
		</div>
	)

}

export class UploadModal extends Component {
  constructor(props) {
    super(props);  
    this.onSelectedChange=this.onSelectedChange.bind(this);
    this.state={
      show:false,
      clearData:false, 
      selected:[],
      progress:20
    }
  }

  handleClose(){
    this.setState({show:false});
  }

  handleShow() {
    this.setState({show:true});
  }

  onSelectedChange(selected) {
    this.setState({selected:selected})
  }

  onChange = (selected) => {
    this.setState({ selected });
  };
  
  resetClearData(item) {
    this.setState({clearData:item})
  }
 
  render(){
    const {show}=this.state;
    return(
      <>

    
      <ButtonIcon onClick={this.handleShow.bind(this)} iconLeft="upload" iconSize="17px" customClassName="header-filter-button upload-component" labelName="Upload a File"/>   
      <Modal
        show={show}
        onHide={this.handleClose.bind(this)}
        backdrop="static"
        keyboard={false}
        className="custom-column-modal-container upload-container"
      >
        <Modal.Header closeButton>
          <Modal.Title>File Upload</Modal.Title>
        </Modal.Header>
        <Modal.Body>
           <div className="finance-detail-table">
                <DropzoneComponent config={componentConfig}
                        eventHandlers={eventHandlers}
                        djsConfig={djsConfig}
                    >
                        <Icons name="cloud-upload" customClassName="cloud-upload" />
                </DropzoneComponent>
           </div>
           <div className="email-validator-file">
                <div className="file-uploaded-container">
                    <Icons
                        name="file-lines"
                        size="18px"
                    />
                    <h3>Lorem_Ipsum-1.xls</h3> 
                    <Icons
                        name="trash-can"
                        size="18px"
                        customClassName="icon-trash-email-upload"
                        containerClass="trash-email-upload-container"
                    />                    
                </div>
                {this.state.progress > 0 && 
                    <div className="progress-bar-container">
                        <progress value={this.state.progress} max="100" />
                        <div className="progress-detail-container">
                            <span className="file-size">13.2 KB</span>
                            <span className="progress-label">{this.state.progress}% uploaded</span> 
                        </div>  
                    </div> 
                } 
                
            </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleClose.bind(this)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={()=>alert("Click Me")}>Save</Button>
        </Modal.Footer>
      </Modal>

      </>
    );
  }
}
